import { TextIconButton } from 'components/shared/IconButton';
import { FormattedMessage } from 'components/shared/Intl';
import { IrreversibleConfirmModal } from 'components/shared/Modals/IrreversibleConfirmModal';
import { FC, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';

export type ResetButtonProps = {
  isDisabled: boolean;
  onReset: () => void;
};

export const ResetButton: FC<ResetButtonProps> = ({ onReset, isDisabled }) => {
  const { formatMessage } = useIntl();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const openConfirmationModal = useCallback(() => setIsModalOpened(true), []);
  const closeConfirmationModal = useCallback(() => setIsModalOpened(false), []);
  const resetFormConfirmed = useCallback(() => {
    closeConfirmationModal();
    onReset();
  }, [closeConfirmationModal, onReset]);
  return (
    <>
      <TextIconButton
        e2e="reset-form-btn"
        iconName="settings_backup_restore"
        isDisabled={isDisabled}
        label={formatMessage({ id: 'form.buttons.Reset', defaultMessage: 'Reset' })}
        onClick={openConfirmationModal}
      />
      <IrreversibleConfirmModal
        onConfirm={resetFormConfirmed}
        onClosed={closeConfirmationModal}
        isOpen={isModalOpened}
        title={<FormattedMessage id="secondaryMarket.resetModal.title" />}
        description={
          <p>
            <FormattedMessage
              id="secondaryMarket.form.warningMessage"
              defaultMessage="You are about to reset your form."
            />
          </p>
        }
      ></IrreversibleConfirmModal>
    </>
  );
};

ResetButton.displayName = 'CpOrderResetForm';
